import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import * as pbi from 'powerbi-client';
import * as pbm from 'powerbi-models';
import { PowerBiReportService } from '../../../powerbi-report/powerbi-report.service';
import { ContrastMode } from '../../../../models/contrast-mode.enum';
import { DtoSubCategory } from '../../../../models/package-center.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { PackageService } from '../../../package-center/package/package.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-student-in-apage',
  templateUrl: './student-in-apage.component.html',
  styleUrl: './student-in-apage.component.scss'
})
export class StudentInAPageComponent implements
  OnInit,
  OnDestroy,
  OnChanges {
  @Input({ required: true })
  accountReference: string | null = null;
  @Input({ required: true })
  studentId: string | null = null;


  subscription: Subscription | null = null;
  powerbiEmbedded: pbi.service.Service;
  reportInstance: pbi.Embed | null = null;

  showReport = false;
  embedConfig: any = {};
  isLoading: boolean = false;

  ContrastMode = ContrastMode;
  currentContrastMode: number = 0;

  report: DtoSubCategory | null = null;
  report_context: DtoSubCategory | null = null;

  constructor(
    private msalService: MsalService,
    private powerBiService: PowerBiReportService,
    private toasterService: ToastrService,
    private packageService: PackageService,
    private sharedService: SharedService,
  ) {
    this.msalService.initialize();
    this.powerbiEmbedded = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
  }

  ngOnInit(): void {

    this.msalService.initialize();
    const savedContrastMode = Number(sessionStorage.getItem('contrastMode')) || 0;
    this.currentContrastMode = savedContrastMode;

    if (this.studentId && this.accountReference)
      this.loadData();

    
  }

  ngOnDestroy(): void {
    this.reportInstance?.off('error');
    this.subscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.studentId && this.accountReference)
      this.loadData();
  }


  print() {
    const embeddedReport = this.reportInstance as pbi.Visual;
    embeddedReport?.print(); 
  }

  loadData() {
    if (this.accountReference == null)
      return;

    const toolkitName = '$SOAP';
    this.packageService.getToolkit(
      this.accountReference,
      toolkitName).subscribe(
        {
          next: (data: DtoSubCategory) => {
            this.report = data;
            this.generateReport();
          },
          error: (err: HttpErrorResponse) => {
            this.toasterService.error(`Error loading toolkit details for "${toolkitName}".\n` + err.error);
          }
        }
      );

  }

  async generateReport() {
    if (!this.report?.reportId) {
      return;
    }

    if (this.isLoading) {

      const reportContainer = document.getElementById('popupReportContainer');

      if (reportContainer) {
        // Reset the existing embedded report (if any)
        this.powerbiEmbedded.reset(reportContainer);
      }

    }

    this.embedConfig = {};
    this.showReport = false;
    this.isLoading = true;
    this.sharedService.setPopUpLoading(false);

    const loadingReport = this.report;
    var apiUrl = this.powerBiService.getApiUrl();
    if (!apiUrl.startsWith('http'))
      apiUrl = document.location.protocol + "//" + document.location.host + apiUrl;

    const client_account = Number(sessionStorage.getItem('client_account'));
    const my_ref_school_id = sessionStorage.getItem('my_ref_school_id');
    const schoolId = Number(sessionStorage.getItem('school_id'));

    let tokenDetails = {
      userAccessToken: '', //response.accessToken
      reportId: loadingReport.reportId,
      clientAccountId: client_account,
      subcategoryId: loadingReport.subCategoryId,
      myRefSchoolId: my_ref_school_id,
      schoolId: schoolId,
      apiUrl: apiUrl
    };

    const showReport = () => {

      //this.fetchReportPages();
      if (this.isLoading == false) return;
      //Give some time for the default powerbi logo to
      setTimeout(() => {
        this.isLoading = false;
        this.sharedService.setPopUpLoading(false);
      }, 2000); // 2000 ms = 2 seconds
    };

    const showReportError = (error: any) => {
      console.error('Error loading Power BI report:', JSON.stringify(error));
      this.toasterService.error(JSON.stringify(error));
      showReport();
    };

    this.sharedService.setPopUpLoading(true);
    this.powerBiService.getEmbedDetails(tokenDetails)
      .subscribe({
        next: (response: any) => {
          var data = response.embedDetails;
          const reportApiurl = data.apiurl;
          this.showReport = true;

          if (data.reportType === 'PaginatedReport') {
            const separator = data.embedUrl.includes('?') ? '&' : '?';
            
            this.embedConfig = {
              type: 'report',//'paginatedReport',
              id: data.reportId,
              embedUrl: data.embedUrl,
              accessToken: data.embedToken.token,
              permissions: pbm.Permissions.Read,
              tokenType: pbi.models.TokenType.Embed, //pbi.models.TokenType.AAD
              settings: {
                commands: {
                  parameterPanel: {
                    enabled: true,
                    expanded: false
                  }
                },
                panes: {
                  filters: { expanded: false, visible: false },
                  pageNavigation: { visible: false }
                }
              },
              parameterValues: [
                { name: 'studentID', value: this.studentId },
                { name: 'apiurl', value: reportApiurl }//,
                //{name:'DataJourney',value: null}
              ]
            };
          }
          else if (data.reportType === 'PowerBIReport') {
            const pageName = '86c52af0ad15d4b40c09';
            const visualName = '983c6d894b168400a3e6';
            this.embedConfig = {
              //type: 'report',
              type: 'visual',
              pageName: pageName,
              visualName: visualName,
              //theme: {themeJson: themeJson},
              tokenType: pbi.models.TokenType.Embed, //pbi.models.TokenType.AAD
              accessToken: data.embedToken.token,
              embedUrl: data.embedUrl,
              permissions: pbi.models.Permissions.Read,
              settings: {
                customLoadingMessage: 'Loading your insights',
                filterPaneEnabled: false,
                navContentPaneEnabled: false,

                background: pbm.BackgroundType.Transparent,
                //theme: { themeJson: themeJson },
                authoringHintsEnabled: false,
                hyperlinkClickBehavior: pbm.HyperlinkClickBehavior.RaiseEvent,
                bars: {
                  statusBar: {
                    visible: true
                  },
                  actionBar: {
                    visible: false
                  }
                },
                layoutType: pbm.LayoutType.Custom,
                //zoomLevel: 0.90,
                //layoutType: pbm.LayoutType.Custom,
                customLayout: {
                  //  pageSize:{
                  //      type: pbm.PageSizeType.Custom,
                  //     width: cWidth,
                  //     height: cHeight
                  //  },
                  displayOption: pbm.DisplayOption.FitToWidth,
                },
              },
              filters: this.getFilterProperties(),
              //slicers: this.getSlicerStates(),
              contrastMode: this.currentContrastMode,
              bookmark: null
              //slicers: null,//reportSlicerStates
              //pageName: startupPage
            };
          }
          else {
            showReportError('Unknown report type ' + data.reportType);
            return;
          }

          const reportContainer = document.getElementById('popupReportContainer');

          if (!reportContainer) return;

          // Reset the existing embedded report (if any)
          this.powerbiEmbedded.reset(reportContainer);

          if (this.showReport) {
            if (data.reportType === 'PaginatedReport') {
              this.reportInstance = this.powerbiEmbedded.embed(reportContainer, this.embedConfig);
              showReport();
            }
            else {
              this.reportInstance = this.powerbiEmbedded.embed(reportContainer, this.embedConfig);
              //const report = this.reportInstance as pbi.Report;
              //const report = this.reportInstance as pbi.Visual;
              this.reportInstance.off('renderingStarted');
              //this.reportInstance.off('loaded');
              this.reportInstance.off('rendered');
              this.reportInstance.off('error');

              var isRendered = false;

              // this.reportInstance.on('loaded',async ()=>{
              //   const pages = await report.getPages();
              //   for (const page of pages) {
              //     console.log("PAGE:", page.displayName, "name:", page.name);

              //     const visuals = await page.getVisuals();

              //     for (const visual of visuals) {
              //       console.log({
              //         name: visual.name,
              //         type: visual.type,
              //         title: visual.title,
              //       });
              //     }
              //   }
              // });

              this.reportInstance.on('renderingStarted', () => {
                isRendered = true;
                showReport();
                this.reportInstance?.off('renderingStarted');
              });

              this.reportInstance.on('rendered', async () => {
                this.reportInstance?.off('rendered');
                //await this.hideSingleSchoolSlicer( report);
                if (!isRendered)
                  showReport();
              });

              this.reportInstance.on('error', (error) => {
                showReportError(error);
              });

            }
          }

        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
            this.report = null;
            this.showReport = false;
            this.isLoading = false;
            this.sharedService.setPopUpLoading(false);
          }
        }
      });
  }
  
  getFilterProperties(): pbm.ReportLevelFilters[] | pbm.OnLoadFilters {
    const client_account = Number(sessionStorage.getItem('client_account') ?? 0);
    const my_ref_school_id_list = sessionStorage.getItem('my_ref_school_id');

    var filters: pbm.ReportLevelFilters[] = [];

    const studentIdFilter =
      {
        $schema: 'http://powerbi.com/product/schema#advanced',
        target: {
          table: 'Dim - Student',
          column: 'student_id',
        },
        logicalOperator: 'And',
        conditions: [{
          value: this.studentId,
          operator: 'Is'
        }]
      } as pbm.IAdvancedFilter;

    filters.push(studentIdFilter);

    if (my_ref_school_id_list && my_ref_school_id_list != '') {
      const schoolList = my_ref_school_id_list.split(',');
      if (client_account == 0 && schoolList.length > 1) {
        this.toasterService.error('Cannot browse multiple schools that belong to differene accounts.');
        throw 'Cannot browse multiple schools that belong to differene accounts.'
      }

      const schoolFilter: pbm.IAdvancedFilter | pbm.ReportLevelFilters =
        schoolList.length == 1 ?
          {
            $schema: 'http://powerbi.com/product/schema#advanced',
            target: {
              table: 'SchoolEntity',
              column: 'My_Reference_School_Code',
            },
            logicalOperator: 'And',
            conditions: [{
              value: schoolList[0],
              operator: 'Is'
            }]
          } as pbm.IAdvancedFilter
          :
          {
            $schema: 'http://powerbi.com/product/schema#basic',
            filterType: pbi.models.FilterType.Basic,
            logicalOperator: "Or",
            target: {
              table: 'SchoolEntity',
              column: 'My_Reference_School_Code',
            },
            operator: 'In',
            values: schoolList
          } as pbm.ReportLevelFilters;

      filters.push(schoolFilter);

    }

    if (client_account > 0) {
      const clientFilter =
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'SchoolEntity',
            column: 'ClientAccountId',
          },
          logicalOperator: 'And',
          conditions: [{
            value: client_account,
            operator: 'Is'
          }]
        } as pbm.IAdvancedFilter;

      filters.push(clientFilter);
    }

    return filters;
  }
}
